import ClearIcon from '@/components/icons/ClearIcon.vue';
import EvolutionChartExportOption from '@/components/EvolutionChartExportOption.vue';
import { EXPORT_SIZES, EXPORT_LIMITS } from "../utils/constants";
import AppSwitch from "@/components/AppSwitch.vue";
export default {
  name: "EvolutionChartExportModal",
  data() {
    return {
      EXPORT_SIZES,
      EXPORT_LIMITS
    };
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    showAxes: {
      type: Boolean
    }
  },
  components: {
    ClearIcon,
    EvolutionChartExportOption,
    AppSwitch
  },
  emits: ["update:modelValue", "copy-chart", "resize", "update:show-axes"],
  computed: {
    modal: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit('update:modelValue', v);
      }
    },
    _showAxes: {
      get() {
        return this.showAxes;
      },
      set(v) {
        this.$emit('update:show-axes', v);
      }
    }
  },
  methods: {
    handleCopy(aspectRatio, showAxes, limit) {
      this._showAxes = showAxes;
      const {
        width,
        height
      } = aspectRatio ?? {
        width: 0,
        height: 0
      };
      this.$emit('copy-chart', {
        withBackground: true,
        width,
        height,
        limit
      });
    },
    handleCopyNoBackground(aspectRatio, showAxes, limit) {
      this._showAxes = showAxes;
      const {
        width,
        height
      } = aspectRatio ?? {
        width: 0,
        height: 0
      };
      this.$emit('copy-chart', {
        withBackground: false,
        width,
        height,
        limit
      });
    }
  }
};